module.exports = __webpack_public_path__ + "static/logo-large-74dd2fa4fd702ef836b28ab34d140ee5.svg";